import { lazy } from "react"

export const AnalyticsLimitsSalesPage = lazy(() => import("./LimitsSalesAnalyticsPage"))